import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/* eslint-disable react/prop-types */
import { useEffect, useRef, useState } from "react";
import { useAppDispatch } from "src/hooks/redux";
import { openOrderSummary, setOrderSummary } from "src/redux/reducers/modals";
import { intCommaWithoutDecimal, splitAndGetDetailsFromLongName, } from "../../../utils/methods";
import styles from "./order-slicing.module.scss";
const OrderSlicingModal = ({ scripData, sliceLimitData, productType, closeModal, isConsentReceived, }) => {
    const [hasFocusOnPopUp, setFocusOnPopUp] = useState(true);
    const getReminderQuantity = () => {
        if (scripData.quantity && sliceLimitData) {
            return scripData.quantity % sliceLimitData.qtyLimit;
        }
        return 0;
    };
    const remainderQuantity = getReminderQuantity();
    const getSliceQtyLimitOrders = () => {
        if (scripData.quantity && sliceLimitData) {
            return (scripData.quantity - remainderQuantity) / sliceLimitData.qtyLimit;
        }
        return 0;
    };
    const dispatch = useAppDispatch();
    const noOfSliceQtyLimitOrders = getSliceQtyLimitOrders();
    const quantityAllowed = sliceLimitData ? sliceLimitData.qtyLimit * 50 : 0;
    const executeRef = useRef(null);
    useEffect(() => {
        const listener = (event) => {
            var _a;
            if ((event.code === "Enter" || event.code === "NumpadEnter") &&
                hasFocusOnPopUp) {
                event.preventDefault();
                (_a = executeRef.current) === null || _a === void 0 ? void 0 : _a.click();
                //isConsentReceived(true);
            }
        };
        document.addEventListener("keydown", listener);
        return () => {
            //unmount cleanup here
            document.removeEventListener("keydown", listener);
            closeModal();
            executeRef.current = undefined;
        };
    }, [hasFocusOnPopUp]);
    const nameBreakUp = splitAndGetDetailsFromLongName(scripData.name);
    // const defaultsingleElement = {
    //   AddReqMgn: 0,
    //   AvlbMgn: 0,
    //   BrokerOrderID: 811874385,
    //   ClientCode: "59949004",
    //   Exch: "N",
    //   ExchOrderID: 0,
    //   ExchType: "D",
    //   LocalOrderID: 2,
    //   Message:
    //     "Order rejected by RMS as margin required is Rs9050134, while available margin is Rs-180962598.06",
    //   RMSResponseCode: -7,
    //   ScripCode: 36187,
    //   Status: -1,
    //   Time: "/Date(1684175400000+0530)/",
    //   name: "NIFTY",
    //   expiry: "25 MAY'23",
    //   IsIntraday: false,
    //   OrderType: "BUY",
    //   Qty: 1800,
    // };
    const singleElement = {
        name: nameBreakUp.name,
        expiry: nameBreakUp.expiry,
        scripType: nameBreakUp.scripType,
        strikeRate: nameBreakUp.strikeRate,
        IsIntraday: productType !== "delivery",
        OrderType: scripData.isBuy ? "BUY" : "SELL",
        Qty: Number(sliceLimitData === null || sliceLimitData === void 0 ? void 0 : sliceLimitData.qtyLimit),
        isBuy: scripData.isBuy,
        AddReqMgn: 0,
        AvlbMgn: 0,
        BrokerOrderID: 0,
        ClientCode: "",
        Exch: scripData.exchange,
        ExchOrderID: 0,
        ExchType: scripData.exchangeType,
        LocalOrderID: 0,
        Message: "",
        RMSResponseCode: 0,
        ScripCode: 0,
        Status: -1,
        Time: "", //NOT IN USE
    };
    const initialOrderSummary = [];
    for (let i = 0; i < noOfSliceQtyLimitOrders; i++) {
        initialOrderSummary.push(singleElement);
    }
    if (remainderQuantity > 0) {
        initialOrderSummary.push(Object.assign(Object.assign({}, singleElement), { Qty: remainderQuantity }));
    }
    return (_jsxs(_Fragment, { children: [_jsxs("div", Object.assign({ className: `${styles.modalHeaderPart} ${styles.maximumOrderHead}`, onClick: () => setFocusOnPopUp(true) }, { children: [_jsxs("h6", Object.assign({ className: "mb-0 larger mediumWeight" }, { children: [_jsx("span", { className: `${styles.exclamationIcon} me-2` }), " Maximum Order Quantity Reached"] })), _jsx("span", Object.assign({ className: "pointer", onClick: () => {
                            closeModal();
                        } }, { children: _jsx("svg", Object.assign({ width: "14", height: "14", viewBox: "0 0 12 12", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: _jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.09938 6.00009L11.7719 1.32729C12.076 1.02334 12.076 0.531906 11.7719 0.22796C11.468 -0.0759865 10.9766 -0.0759865 10.6726 0.22796L5.99993 4.90076L1.32737 0.22796C1.02329 -0.0759865 0.532001 -0.0759865 0.228062 0.22796C-0.0760206 0.531906 -0.0760206 1.02334 0.228062 1.32729L4.90062 6.00009L0.228062 10.6729C-0.0760206 10.9768 -0.0760206 11.4683 0.228062 11.7722C0.379533 11.9238 0.578696 12 0.777716 12C0.976736 12 1.17576 11.9238 1.32737 11.7722L5.99993 7.09942L10.6726 11.7722C10.8242 11.9238 11.0233 12 11.2223 12C11.4213 12 11.6203 11.9238 11.7719 11.7722C12.076 11.4683 12.076 10.9768 11.7719 10.6729L7.09938 6.00009Z", fill: "white" }) })) }))] })), _jsxs("div", Object.assign({ className: styles.modalBodyPart }, { children: [scripData.quantity && quantityAllowed >= scripData.quantity && (_jsxs("div", Object.assign({ className: `${styles.maximumOrderContent}` }, { children: [_jsxs("div", Object.assign({ className: `${styles.paraText} d-flex justify-content-center` }, { children: [_jsxs("p", { children: ["Placed Quantity:", _jsxs("span", { children: [" ", intCommaWithoutDecimal(scripData === null || scripData === void 0 ? void 0 : scripData.quantity)] })] }), _jsx("span", Object.assign({ className: `${styles.verticalDivider} px-3` }, { children: "|" })), _jsxs("p", { children: ["Max Order Quantity:", _jsxs("span", { children: [" ", intCommaWithoutDecimal(sliceLimitData === null || sliceLimitData === void 0 ? void 0 : sliceLimitData.qtyLimit)] })] })] })), _jsx("p", Object.assign({ className: "mt-4 mb-2" }, { children: "To continue, your order will be sliced in to" })), _jsxs("div", Object.assign({ className: `${styles.borderedContent} pb-2` }, { children: [_jsxs("p", { children: [noOfSliceQtyLimitOrders, " orders of\u00A0", intCommaWithoutDecimal(sliceLimitData === null || sliceLimitData === void 0 ? void 0 : sliceLimitData.qtyLimit), "\u00A0Qty"] }), remainderQuantity > 0 && (_jsxs("p", { children: ["1 order of ", intCommaWithoutDecimal(remainderQuantity), " Qty."] }))] })), _jsxs("div", Object.assign({ className: "buttonWrapperLarge mt-4" }, { children: [_jsx("button", Object.assign({ type: "submit", className: "btnType2 px-4 me-3", onClick: () => {
                                            closeModal();
                                        } }, { children: "Cancel" })), _jsx("button", Object.assign({ type: "submit", className: "btnType1", ref: executeRef, onClick: () => {
                                            isConsentReceived(true);
                                            dispatch(setOrderSummary(true));
                                            dispatch(openOrderSummary({ orderResponseData: initialOrderSummary }));
                                        } }, { children: "Continue" }))] }))] }))), scripData.quantity && quantityAllowed < scripData.quantity && (_jsxs("div", Object.assign({ className: `${styles.maximumOrderMessage}` }, { children: [_jsxs("p", Object.assign({ className: "mt-4" }, { children: ["Maximum limit reached, please place below\u00A0", intCommaWithoutDecimal(quantityAllowed), "\u00A0quantity."] })), _jsx("div", Object.assign({ className: "buttonWrapperLarge mt-5" }, { children: _jsx("button", Object.assign({ type: "submit", className: "btnType1", onClick: closeModal }, { children: "OK" })) }))] })))] }))] }));
};
export default OrderSlicingModal;
